import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatchContactFilter } from 'src/app/models/match-contact-filter.model';
import { TokenHelper } from 'src/app/services/helpers/token.helper';
import { ReplaceContact } from 'src/app/models/replace-contact.model';
import { MatchContactItem } from 'src/app/models/match-contact-item.model';
import { IContactService } from 'src/app/services/interfaces/contact-service.interface';
import { Contact } from 'src/app/models/contact.model';
import { ToastService } from 'src/app/services/ui/toast.service';
import { ToastType } from '../../toast/models/toast-type.enum';



@Component({
	selector: 'match-contacts[service]',	// "service" property MUST be provided with every "match-contacts" use, otherwise compilation will fail
	templateUrl: './match-contacts.component.html',
	styleUrls: ['./match-contacts.component.scss']
})
export class MatchContactsComponent implements OnInit, OnChanges, OnDestroy {
	@Input('filter') filter: MatchContactFilter;
	@Input('service') service: IContactService<Contact>;

	@Output('userAlreadyExistsByEmailOrPhone') userAlreadyExistsByEmailOrPhone$: EventEmitter<boolean> = new EventEmitter();
	@Output('replaceContact') replaceContact$: EventEmitter<ReplaceContact> = new EventEmitter();
	@Output('applyContactToSite') applyContactToSite$: EventEmitter<number> = new EventEmitter();
	@Output('showContact') showContact$: EventEmitter<number> = new EventEmitter();

	public matchingContacts: MatchContactItem[] = [];
	public isMatchContactsListLoading = false;

	private subscription$: Subscription = new Subscription();
	constructor(
		private activatedRoute: ActivatedRoute
	) { }


	ngOnInit(): void {

	}

	ngOnDestroy(): void {
		this.subscription$.unsubscribe();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes != null && changes.filter != null && changes.filter.currentValue != null) {
			this.search.call(this);
		}

		if (changes && changes.filter != null && changes.filter.currentValue == null) {
			this.matchingContacts = [];
			this.userAlreadyExistsByEmailOrPhone$.emit(false);
		}
	}

	private search(): void {
		this.matchingContacts = [];
		this.isMatchContactsListLoading = true;
		this.subscription$.add(
			this.service.getMatchingContacts(TokenHelper.getToken(this.activatedRoute), this.filter)
				.subscribe(contacts => {
					this.matchingContacts = contacts;
					this.userAlreadyExistsByEmailOrPhone$.emit(this.matchingContacts.some(a => a.requiresUniqueness));
					this.isMatchContactsListLoading = false;
				}, (result) => {
					this.isMatchContactsListLoading = false;

					if (result.status === 403) {
						ToastService.pushToast({
							icon: 'error',
							text: 'You are not allowed to add this email or phone number to the list!',
							type: ToastType.Error,
							timeout: 4500
						});
					}
				}));
	}

	public replaceContact(contactRefId: number): void {
		this.replaceContact$.emit({ currentContactId: this.filter.contactId, replacementRefId: contactRefId } as ReplaceContact);
	}

	public applyToSite(contactRefId: number): void {
		this.applyContactToSite$.emit(contactRefId);
	}

	public show(contactRefId: number): void {
		this.showContact$.emit(contactRefId);
	}
}
